<template>
  <app-modal :modal-id="modalId" :title="modalTitle" :preloader="preloader"
                @submit="submit" @close-modal="closeModal" modal-size="large">
        <template slot="header">
            <h5 class="modal-title" id="ModalLabel">{{ modalTitle }}</h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                :data-url='selectedUrl ? `salary-advances/${inputs.id}` : `salary-advances`'>
                <div class="row">
                    <!-- Employee Select Input -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="employee">
                                {{ $t('employee') }}
                                <span style="color: crimson">*</span>
                            </label>
                            <app-input class="w-100" id="employee" v-model="inputs.employee_id" 
                                    :list="employeeList" list-value-field="name" :placeholder="$t('choose_one')" 
                                    type="search-select" :required="true" />
                        </div>
                    </div>
                    <!-- Date Input -->
                    <div class="col-md-12">
                        <app-form-group
                            :label="$t('date')"
                            type="date"
                            v-model="inputs.date"
                            :placeholder="$t('date')"
                            :required="true"
                        />
                    </div>
                    <!-- Amount Input -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="amount">
                                {{ $t('amount') }}
                                <span style="color: crimson">*</span>
                            </label>
                            <app-input id="amount" type="number" step="0.01" v-model="inputs.amount"
                                :placeholder="$t('amount')" :required="true" />
                        </div>
                    </div>
                    <!-- Payroll Period Select Input -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="payroll_period">
                                {{ $t('payroll_period') }}
                                <span style="color: crimson">*</span>
                            </label>
                            <app-input class="w-100" id="payroll_period" v-model="inputs.payroll_period_id" 
                                    :list="payrollPeriodList" list-value-field="name" :placeholder="$t('choose_one')" 
                                    type="search-select" :required="true" />
                        </div>
                    </div>
                    <!-- Status Select Input -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="status">
                                {{ $t('status') }} 
                                <span style="color: crimson">*</span>
                            </label>
                            <app-input class="w-100" id="status" v-model="inputs.status"
                                :list="statusList" :placeholder="$t('status')" type="select"
                                :required="true" />
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">{{ $t('save') }}</button>
        </template>
    </app-modal>
</template>

<script>
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import {errorMessageForArray} from '../../../../common/Helper/Support/FormHelper';
import {formatDateForServer} from "../../../../common/Helper/Support/DateTimeHelper";
import { ModalMixin } from '../../../Mixins/ModalMixin';
import {mapState} from 'vuex';

export default {
    name: 'SalaryAdvanceAddEditModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
        },
    },
    computed: {
        ...mapState({
            employeeList: state => state.selects.employeeList,
            payrollPeriodList: state => state.selects.payrollPeriodList,
        })
    },
    data() {
        return {
            errorMessageForArray,
            preloader: false,
            modalId: 'salary-advance-add-edit-modal',
            inputs: {
                employee_id: '',
                date: '',
                amount: '',
                payroll_period_id: '',
                status: 'pending',
            },
            isModalActive: false,
            modalTitle: `${this.$t('salary-advance')}`,
            statusList: [
                {
                    id: 'pending',
                    value: this.$t('pending')
                },
                {
                    id: 'approved',
                    value: this.$t('approved')
                },
                {
                    id: 'rejected',
                    value: this.$t('rejected')
                },
            ],
        }
    },
    methods: {
        submit() {
            let formData = this.inputs;

            // Format date for server
            formData.date = formatDateForServer(formData.date);

            this.save(formData);
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccessFromGetEditData({ data }) {
            this.inputs = data;
            this.inputs.date = data.date ? new Date(data.date) : '';
            this.preloader = false;
        },
    },
    mounted() {
        this.$store.dispatch('getEmployees');
        this.$store.dispatch('getPayrollPeriods');

        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
}
</script>

<style>

</style>